module.exports = __webpack_public_path__ + "static/media/sow-section-3-teacher.3567ba06.svg";